import {
  ProductCategory,
  ProductCategoryApi,
  ProductCategoryFormData,
  ProductCategoryFormDataApi,
  ProductCategoryFormErrors,
  ProductCategoryFormErrorsApi,
} from '../types/categories'

export class ProductCategoryMappers {
  public static fromApi(category: ProductCategoryApi): ProductCategory {
    return {
      id: category.id,
      name: category.product_category_name,
      products: category.products?.map((product) => ({ id: product.product_id, name: product.product_name })),
      description: category.descr,
    }
  }

  public static manyFromApi(raw: ProductCategoryApi[]): ProductCategory[] {
    return raw.map((item) => ProductCategoryMappers.fromApi(item))
  }

  public static formDataToApi(formData: ProductCategoryFormData): ProductCategoryFormDataApi {
    return {
      product_category_id: formData.id,
      product_category_name: formData.name,
      descr: formData.description,
    }
  }

  public static formErrorsFromApi(errors: ProductCategoryFormErrorsApi): ProductCategoryFormErrors {
    return {
      id: errors.product_category_id,
      name: errors.product_category_name,
      description: errors.descr,
      _custom: errors._custom,
    }
  }

  public static formInitializer(category: ProductCategory): ProductCategoryFormData {
    return {
      id: category.id.toString(),
      name: category.name,
      description: category.description || '',
    }
  }
}
